import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { SupportStepsModule } from 'src/app/components/support-steps/support-steps.module';
import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { AdminSupportStepRulesetsRoutingModule } from './admin-support-step-rulesets-routing.module';
import { AdminSupportStepRulesetsComponent } from './admin-support-step-rulesets.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AdminSupportStepRulesetsRoutingModule,
    SharedPipesModule,
    SupportStepsModule,
    NgxTippyModule,
  ],
  declarations: [AdminSupportStepRulesetsComponent],
})
export class AdminSupportStepRulesetsModule {}
